import { Box, Fab, Grid, Tooltip, Typography } from "@mui/material";
import { useNavigate } from "react-router";

import { useEffect, useState } from "react";

import { setUserDetail, setbusinessChooseTab } from "../app/store/reducer";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router/dist";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import PersonIcon from "@mui/icons-material/Person";
import StorefrontIcon from "@mui/icons-material/Storefront";
import TableBarIcon from "@mui/icons-material/TableBar";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import SearchIcon from "@mui/icons-material/Search";
import HandshakeIcon from "@mui/icons-material/Handshake";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import { routePath } from "../constants/routePath";
import LogOutPop from "./logoutPop";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { capitalizeFirstLetter } from "../app/common/commonFunction";
export default function InstituteSidebar() {
  const navigate = useNavigate();
  const headerMenu = useSelector((state) => state.reducer.headerMenu);
  const [header1, setHeader1] = useState([]);
  const [header2, setHeader2] = useState([]);

  // const arrN = (urlHeaderMenu) => {
  //   let arr1 = [...header1];
  //   let arr2 = [...header2];

  //   if (arr1.length == 0) {
  //     urlHeaderMenu.forEach((element, index) => {
  //       if (index % 2 == 0) {
  //         arr1.push(element);
  //       } else {
  //         arr2.push(element);
  //       }
  //       setHeader1(arr1);
  //       setHeader2(arr2);
  //     });
  //   }
  // };
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab,
  );

  const iconsObj = {
    PersonIcon: PersonIcon,
    StorefrontIcon: StorefrontIcon,
    TableBarIcon: TableBarIcon,
    TableRestaurantIcon: TableRestaurantIcon,
    SearchIcon: SearchIcon,
    HandshakeIcon: HandshakeIcon,
    DashboardIcon: DashboardIcon,
    CurrencyRupeeOutlinedIcon: CurrencyRupeeOutlinedIcon,
    SettingsOutlinedIcon: SettingsOutlinedIcon,
    LockOutlinedIcon: LockOutlinedIcon,
    HeadsetMicOutlinedIcon: HeadsetMicOutlinedIcon,
    ShareOutlinedIcon: ShareOutlinedIcon,
    LogoutOutlinedIcon: PowerSettingsNewIcon,
  };
  const sideBarMenu = useSelector((state) => state.reducer.sideBarMenu);
  //   const institute = useSelector(
  //     (state) => state.reducer.institute
  //   );
  const institute = useSelector((state) => state.reducer.institute);

  const dispatch = useDispatch();

  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(-1);
  useEffect(() => {
    const indexRoute3 = institute.findIndex(
      (it) => it.route === location.pathname,
    );

    setCurrentPage(indexRoute3);
  }, [location.pathname]);

  useEffect(() => {
    if (institute[currentPage]?.tab) {
      dispatch(
        setbusinessChooseTab({
          value: institute[currentPage]?.tab[0]?.value,
          label: institute[currentPage]?.tab[0]?.label,
        }),
      );
    } else {
      dispatch(
        setbusinessChooseTab({
          value: institute[currentPage]?.value,
          label: "",
        }),
      );
    }
  }, [currentPage]);
  return (
    <Grid
      container
      spacing={0}
      sx={{
        pl: "5px",
        position: "sticky",
        top: "104px",
        background: "#3695b6",

        background: "#E3E3FF",
        overflowY: "auto",
        // maxHeight: "calc(100vh - 60px)",

        scrollbarWidth: "thin",
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": {},
        "&::-webkit-scrollbar-thumb": {
          // background: (theme) => theme.palette.secondary.main, // Color of the thumb (scrollbar handle)
          borderRadius: "6px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          // background: "#FFC107",
        },
      }}
    >
      <Grid sx={{ height: "auto" }} item md={12}>
        {institute?.map((item, index) => {
          const indexRoute = institute.findIndex(
            (it) => it.systemFuctionName === item.systemFuctionName,
          );
          const IconComponent = iconsObj[institute[indexRoute]?.icon];

          const indexRouteRilg = headerMenu.findIndex(
            (it) => it.systemFuctionName === item.systemFuctionName,
          );

          if (!headerMenu[indexRouteRilg]?.systemFuctionName) {
            return;
          }
          return (
            <>
              {/* <Box
                key={"siderbar" + index}
                bgcolor="primary"
                sx={{
                  padding:
                    item.systemFuctionName === "Sign Out" ? "4px" : "10px",
                  borderBottom:
                    index !== institute.length - 1
                      ? currentPage === index && item.tab
                        ? ""
                        : "1px solid #ADADCD"
                      : "",
                  background:
                    currentPage === index && !item?.tab ? "#C0BFFF" : "",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  fontFamily: "'Montserrat', sans-serif",
                  transition: "0.3s",
                }}
                onClick={async (e) => {
                  navigate(item?.route);
                }}
              >
                <Typography
                  variant="standard"
                  color="#01008B"
                  sx={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontWeight: currentPage === index ? "600" : "400",
                    fontSize: {
                      xs: "12px",
                      sm: "10px",
                      md: "13px",
                      lg: "15px",
                    },
                  }}
                >
                  {" "}
                  {(function () {
                    const indexRoute = headerMenu.findIndex(
                      (it) => it.systemFuctionName === item.systemFuctionName,
                    );
                    if (item.systemFuctionName == "Bulk Messages") {
                      return "Bulk Messages";
                    }

                    return capitalizeFirstLetter(
                      headerMenu[indexRoute]?.regionalFunctionName,
                    );
                  })()}
                </Typography>
                {item.tab ? (
                  currentPage === index ? (
                    <KeyboardArrowDownIcon />
                  ) : (
                    <KeyboardArrowRightIcon />
                  )
                ) : (
                  ""
                )}
              </Box> */}
              {currentPage === index && item.tab && (
                <Box
                  sx={{ display: "block", borderBottom: "1px solid #ADADCD" }}
                >
                  {item?.tab?.map((ele, index) => {
                    return (
                      <Box
                        sx={{
                          background:
                            businessChooseTab?.value == ele.value
                              ? "#C0BFFF"
                              : "",
                        }}
                      >
                        <ul>
                          <li style={{ color: "#01008B" }}>
                            <Box
                              bgcolor="primary"
                              onClick={() => {
                                console.log(" valuevaluevalue ", {
                                  value: ele.value,
                                });
                                dispatch(
                                  setbusinessChooseTab({
                                    value: ele.value,
                                    label: ele.label,
                                  }),
                                );
                                // dispatch(setbusinessChooseTab({ value: ele.value }));
                              }}
                              variant="standard"
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",

                                cursor: "pointer",
                                padding: "7px 0px",
                                fontFamily: "'Montserrat', sans-serif",
                                transition: "0.3s",
                              }}
                              color={
                                businessChooseTab?.value == ele.value
                                  ? "#01008B"
                                  : "#01008B"
                              }
                              textAlign={"left"}
                            >
                              <Typography
                                variant="standard"
                                sx={{
                                  fontFamily: "'Montserrat', sans-serif",
                                  fontSize: {
                                    xs: "12px",
                                    sm: "10px",
                                    md: "13px",
                                    lg: "15px",
                                  },
                                  fontWeight: "400",
                                }}
                                color={
                                  businessChooseTab?.value == ele.value
                                    ? "#01008B"
                                    : "#01008B"
                                }
                                textAlign={"left"}
                              >
                                {capitalizeFirstLetter(ele.label)}
                              </Typography>
                              {/* {businessChooseTab?.value==ele.value &&( <KeyboardArrowRightIcon sx={{color:'#127093'}}/>)} */}
                            </Box>
                          </li>
                        </ul>
                      </Box>
                    );
                  })}
                </Box>
              )}
            </>
          );
        })}
      </Grid>
      <LogOutPop open={open} setOpen={setOpen} />
    </Grid>
    // </Box>
  );
}
